/**
 * Arabic for the safety boards on the platform — safety reports, the hazard
 * register, the incident register and anomaly acknowledgements.
 * Proposed; pending native aviation review. "Hazard" is خطر, "risk" is مخاطرة,
 * "control" is إجراء ضبط, as in docs/ARABIC-GLOSSARY.md.
 */
const ar: Record<string, string> = {
  // FeedNotice
  "FROM THE PLATFORM": "من المنصة",
  "{hz} hazards, {sr} safety reports and {inc} incidents on this board are from the platform.":
    "{hz} من المخاطر و{sr} من تقارير السلامة و{inc} من الحوادث في هذه اللوحة مصدرها المنصة.",
  "The safety registers on this board are read from the platform.":
    "سجلات السلامة في هذه اللوحة مقروءة من المنصة.",
  "Not read for your role: {why}.": "لم يُقرأ لدورك: {why}.",

  // SafetyFeed
  "your role does not hold {p}": "دورك لا يملك الصلاحية {p}",

  // writes/safety.ts
  "Choose the security category. The security register takes no entry without one.":
    "اختر الفئة الأمنية. لا يقبل السجل الأمني أي قيد بدونها.",
  "Notify {to} within {hours} hours.": "أبلغ {to} خلال {hours} ساعة.",
  "the regulator": "الجهة التنظيمية",
  "Work order {wo} raised.": "صدر أمر العمل {wo}.",
  "The photographs did not reach the work order: {why}": "لم تصل الصور إلى أمر العمل: {why}",
  "It is still open on the platform: {why}": "ما زال مفتوحاً على المنصة: {why}",
  "This incident is not on the platform yet, so its status stays on this page.":
    "هذه الحادثة ليست على المنصة بعد، لذا تبقى حالتها في هذه الصفحة.",
  "{ref} is now {status} on the platform.": "أصبحت حالة {ref} على المنصة: {status}.",
  "Nothing to acknowledge.": "لا شيء للإقرار به.",
  "Acknowledgement saved on the platform.": "حُفظ الإقرار على المنصة.",

  // SafetyDialogs — reports
  "Your role does not hold {p}, so the platform will not take this.":
    "دورك لا يملك الصلاحية {p}، لذا لن تقبل المنصة هذا.",
  "NOT ASSESSED": "غير مُقيَّم",
  "Report filed": "قُدِّم التقرير",
  "{ref} is on the platform.": "{ref} على المنصة.",
  "You marked this as an immediate danger. Tell the duty manager by radio or phone now. This screen alerts nobody.":
    "وصفت هذا بأنه خطر فوري. أبلغ مدير المناوبة باللاسلكي أو الهاتف الآن. هذه الشاشة لا تنبّه أحداً.",
  "File a safety report": "قدّم تقرير سلامة",
  "About hazard {ref}: {title}": "بشأن الخطر {ref}: {title}",
  "About hazard {ref}.": "بشأن الخطر {ref}.",
  "Stand, taxiway, room or system": "موقف أو ممر أو غرفة أو نظام",
  "In your own words: what you saw, when, and what could go wrong.":
    "بكلماتك: ماذا رأيت، ومتى، وما الذي قد يسوء.",
  "WHO SEES YOUR NAME": "من يرى اسمك",
  "The place stays with the report but is not listed with it.":
    "يبقى المكان مع التقرير لكنه لا يظهر في القائمة.",
  "This is an immediate danger. I will also tell the duty manager by radio.":
    "هذا خطر فوري. سأبلغ مدير المناوبة باللاسلكي أيضاً.",
  "Filing…": "جارٍ التقديم…",
  "File the report": "قدّم التقرير",
  "Safety report {ref}": "تقرير السلامة {ref}",
  "Filed reports are read by the safety office. Your role cannot open them.":
    "يقرأ مكتب السلامة التقارير المقدَّمة. لا يستطيع دورك فتحها.",
  "This report is not on the platform's register.": "هذا التقرير ليس في سجل المنصة.",
  "{ref} is now {status}.": "أصبحت حالة {ref}: {status}.",
  "{ref} is tied to {hazard}.": "رُبط {ref} بالخطر {hazard}.",
  "{ref} is tied to no hazard.": "{ref} غير مربوط بأي خطر.",
  "{ref} raised from this report.": "سُجّل {ref} من هذا التقرير.",
  "Nothing of the account was copied into it.": "لم يُنسخ إليه شيء من الرواية.",
  "STATUS": "الحالة",
  "immediate danger": "خطر فوري",
  "FILED": "تاريخ التقديم",
  "BY": "بواسطة",
  "Anonymous. No name was ever kept.": "مجهول الهوية. لم يُحفظ أي اسم إطلاقاً.",
  "Confidential. Only the safety office can see the name.": "سرّي. مكتب السلامة وحده يرى الاسم.",
  "OUTCOME": "النتيجة",
  "Protected. Open the report to read it.": "محمي. افتح التقرير لقراءته.",
  "MOVE IT ON": "انقله إلى المرحلة التالية",
  "Save the status": "احفظ الحالة",
  "TIE IT TO A HAZARD": "اربطه بخطر",
  "Save the link": "احفظ الربط",
  "Or raise a new hazard from it. Nothing of the account is copied; write only what can be shared.":
    "أو سجّل منه خطراً جديداً. لا يُنسخ شيء من الرواية؛ اكتب فقط ما يمكن مشاركته.",
  "Choose a category": "اختر فئة",
  "Raise the hazard": "سجّل الخطر",

  // SafetyDialogs — hazards
  "Raise a hazard": "سجّل خطراً",
  "A hazard is a condition that could cause harm. It stays on the register until somebody closes it with a reason.":
    "الخطر حالة قد تسبب ضرراً. يبقى في السجل حتى يغلقه أحد مع ذكر السبب.",
  "Area or system": "المنطقة أو النظام",
  "Department or role": "القسم أو الدور",
  "Next you score it. Until then it shows as not assessed, never as fine.":
    "بعد ذلك تقيّمه. وحتى ذلك الحين يظهر غير مُقيَّم، ولا يظهر سليماً أبداً.",
  "Raising…": "جارٍ التسجيل…",
  "This hazard is not on the platform's register, or your role cannot read it.":
    "هذا الخطر ليس في سجل المنصة، أو لا يستطيع دورك قراءته.",
  "Scored {index}: {band}.": "التقييم {index}: {band}.",
  "Review by {date}.": "المراجعة قبل {date}.",
  "The band comes from the installed matrix, cell by cell.":
    "يأتي التصنيف من المصفوفة المعتمدة، خانةً خانة.",
  "Save the score": "احفظ التقييم",
  "Control {n} added.": "أُضيف إجراء الضبط {n}.",
  "Hazard is now {status}.": "أصبحت حالة الخطر: {status}.",
  "No controls recorded yet.": "لم يُسجَّل أي إجراء ضبط بعد.",
  "In place": "مطبَّق",
  "Drop": "أسقِط",
  "in place": "مطبَّق",
  "dropped": "أُسقط",
  "ADD A CONTROL": "أضف إجراء ضبط",
  "A control with no due date can never show as overdue.":
    "إجراء الضبط بلا تاريخ استحقاق لا يمكن أن يظهر متأخراً أبداً.",
  "Add the control": "أضف إجراء الضبط",
  "The risk is accepted.": "قُبلت المخاطرة.",
  "Nobody has scored this hazard, so there is no risk to accept. Score it first.":
    "لم يقيّم أحد هذا الخطر، فلا توجد مخاطرة لقبولها. قيّمه أولاً.",
  "Accepting a risk does not remove it. The hazard stays on the register and comes back at its review date. Your name is recorded.":
    "قبول المخاطرة لا يزيلها. يبقى الخطر في السجل ويعود في تاريخ مراجعته. يُسجَّل اسمك.",
  "Accept the risk": "اقبل المخاطرة",
  "{ref} is {status}.": "حالة {ref}: {status}.",
  "This hazard is scored intolerable. Closing it means accepting that risk, with your name and a reason.":
    "هذا الخطر مُقيَّم بأنه غير مقبول. إغلاقه يعني قبول تلك المخاطرة، مع اسمك وسبب.",
  "Nobody has scored this hazard. Closing it is recorded as closed without an assessment.":
    "لم يقيّم أحد هذا الخطر. يُسجَّل إغلاقه على أنه مغلق دون تقييم.",
  "Close the hazard": "أغلق الخطر",
};

export default ar;
